(function() { window.GUID_7b298f42_800f_47a5_85b6_f7e27004ef04 = { getGuid: function() { return "7b298f42-800f-47a5-85b6-f7e27004ef04"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class HorizontalBarChart {
            constructor() {
                this.id = CS.Helper.generateRandomId();
            }
        }
        Controls.HorizontalBarChart = HorizontalBarChart;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=HorizontalBarChart.js.map
